/* istanbul igore file */
import React from 'react';
import { useTranslation } from 'react-i18next';
import "./error.scss";

export default function ProposalError() {
  const { t } = useTranslation();
  return <div data-testid="error-event" className="no-event"><div className="error-message">{t('event.errors.500')}</div></div>;
}